'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dSource$002dVar from "./com.raquo.airstream.state.-Source-Var.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$() {
}
export { $c_Lcom_raquo_airstream_state_Var$ as $c_Lcom_raquo_airstream_state_Var$ };
$p = $c_Lcom_raquo_airstream_state_Var$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$() {
}
export { $h_Lcom_raquo_airstream_state_Var$ as $h_Lcom_raquo_airstream_state_Var$ };
$h_Lcom_raquo_airstream_state_Var$.prototype = $p;
$p.dM = (function(initial) {
  return new $j_com$002eraquo$002eairstream$002estate$002e$002dSource$002dVar.$c_Lcom_raquo_airstream_state_SourceVar(new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(initial));
});
var $d_Lcom_raquo_airstream_state_Var$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_Var$, "com.raquo.airstream.state.Var$", ({
  hl: 1
}));
export { $d_Lcom_raquo_airstream_state_Var$ as $d_Lcom_raquo_airstream_state_Var$ };
var $n_Lcom_raquo_airstream_state_Var$;
function $m_Lcom_raquo_airstream_state_Var$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$)) {
    $n_Lcom_raquo_airstream_state_Var$ = new $c_Lcom_raquo_airstream_state_Var$();
  }
  return $n_Lcom_raquo_airstream_state_Var$;
}
export { $m_Lcom_raquo_airstream_state_Var$ as $m_Lcom_raquo_airstream_state_Var$ };
